import { Expose, Transform, Type } from 'class-transformer';
import { Model } from '@shared-features/models/model';
import { WaitingChargeStatus } from '../enums/waiting-charge-status.enum';
import { User } from '@features/users/models/user';

export class WaitingChargeLogs extends Model {
  @Expose() id!: number;
  @Expose() pickupWaitingTimeMinutes!: number;
  @Expose() dropoffWaitingTimeMinutes!: number;
  @Expose() calculatedTime!: number;
  
  @Expose() customerCost!: number;
  @Expose() fleetCost!: number;
  
  @Expose() chargeStatus!: WaitingChargeStatus;
  @Expose() isApproved!: boolean;
  
  @Type(() => User)
  @Expose() approvedBy!: User | null;

  @Transform(({ value }) => (value ? new Date(value) : null))
  @Expose()
  approvedAt!: Date | null;
}
